import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EntitiesViewContext, LoansViewContext, ProfileViewContext } from '../../../Private';
import { Avatar, Divider } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useGetUserLoggin } from 'services/user/querys';
import { LoanContext } from 'scenes/Private/Dashboard/Dashboard';

const avatarColors = ["purple", "yellow", "blue"];
const colorSelected = avatarColors[Math.floor(Math.random() * avatarColors.length)];

const BarDashboard = () => {

  const naviagate = useNavigate();

  const { data: user, fetching: loadingUser } = useGetUserLoggin();
  const loanSelect = useContext(LoanContext);

  const { visible: visibleEntities, setHandlerVisible: setVisibleEntities }: any = useContext(EntitiesViewContext);
  const { visible: visibleLoans, setHandlerVisible: setVisibleLoans, lockedDeadLayout, setLockedDeadLayout }: any = useContext(LoansViewContext);
  const { visible: visibleProfile, setHandlerVisible: setVisibleProfile }: any = useContext(ProfileViewContext);
  const [autoLoansOpened, setAutoLoansOpened] = useState(false);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('fromOAuth');
    window.dispatchEvent(new Event("storage"));
    naviagate("/");
    naviagate(0);
  }

  const activeOption = (visible: 'loans' | 'entities' | 'profile') => {
    setVisibleLoans(visible === 'loans');
    setVisibleEntities(visible === 'entities');
    setVisibleProfile(visible === 'profile');
  }

  useEffect(() => {
    const isSelectedLoanDead = loanSelect && 'state' in loanSelect && loanSelect.state === 'dead';
    
    if (isSelectedLoanDead && !autoLoansOpened) {
      activeOption('loans');
      setLockedDeadLayout(true);
      setAutoLoansOpened(true);
    } else if (isSelectedLoanDead && !lockedDeadLayout) {
      setLockedDeadLayout(true);
    } else if (!isSelectedLoanDead && lockedDeadLayout) {
      setLockedDeadLayout(false);
    }
  }, [autoLoansOpened, loanSelect, lockedDeadLayout, setLockedDeadLayout]);
  
  return (
    <div className="BarDashboard-space">
      <div className="BarDashboard">
        <div className="box">
          {/*<div className="notification">
            <div className="number-ammoint">
              <span>9</span>
            </div>
            <img className="icon bell" src={bellSvg} alt="bell" />
          </div>*/}
        </div>
        <div style={{ width: 40, margin: 'auto' }}>
          <Divider style={{ background: '#ccd3db', margin: 0 }}/>
        </div>
        <div className="box box-medium">
          <div className="menu-item">
            <Link className={`link  link-with-hover ${visibleLoans && 'link-active' }`} to="./" onClick={() => activeOption('loans')}>
              <div className="brief"/>
              <span>Loans</span>
            </Link>
            <Link className={`link  link-with-hover ${visibleEntities && 'link-active' }`} to="./" onClick={() => activeOption('entities')}>
              <div className="award"/>
              <span>Entities</span>
            </Link>
          </div>
        </div>
        <div style={{ width: 40, margin: 'auto' }}>
          <Divider style={{ background: '#ccd3db', margin: 0 }}/>
        </div>
        <div className="box box-end">
          <Link className="link link-with-hover" onClick={logout} to="">
            <div className="icon-logout"/>
            <span>Log out</span>
          </Link>
          <Link className={`link  link-with-hover ${visibleProfile && 'link-active' }`} to="./" onClick={() => activeOption('profile')}>
            <Avatar 
              src={!loadingUser && user?.avatar?.url} 
              size={35} 
              className={`avatar avatar-${colorSelected}`}
            >
              {!user?.avatar && (user?.name?.charAt(0) + (user?.lastName?.charAt(0) || ''))}
              {(loadingUser) && <LoadingOutlined />}
            </Avatar>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default BarDashboard;
